import React, { useEffect } from "react";
import { useAuth } from "../Context/AuthContext/AuthContext";
import { useNavigate } from "react-router-dom";

const UserNotSignedInRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isUserLoggedIn, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isUserLoggedIn || user) {
      //navigate(-1);
      navigate("/", { replace: true });
    }
  }, [isUserLoggedIn, navigate, user]);

  return <>{!isUserLoggedIn || !user ? children : null}</>;
};

export default UserNotSignedInRoute;
